import { getLogMoniterEnableKey } from "./business-details-service";


const logger = {
    error: (...args) => {
        // checking is Logging enabled or not.
        const isLoggingEnabled = getLogMoniterEnableKey();
        if (isLoggingEnabled) {
            console.error(...args);
        }
    },
    warn: (...args) => {
        // checking is Logging enabled or not.
        const isLoggingEnabled = getLogMoniterEnableKey();
        if (isLoggingEnabled) {
            console.warn(...args);
        }
    },
    info: (...args) => {
        // checking is Logging enabled or not.
        const isLoggingEnabled = getLogMoniterEnableKey();
        if (isLoggingEnabled) {
            console.info(...args);
        }
    },
    debug: (...args) => {
        // checking is Logging enabled or not.
        const isLoggingEnabled = getLogMoniterEnableKey();
        if (isLoggingEnabled) {
            console.log(...args);
        }
    },
};

export default logger;
